module.exports = __webpack_public_path__ + "static/media/turtle.58363fc1.svg";